<template>
  <div class="">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('bid_responses')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="opencreate"
          >
            {{ $t("new_task") }}
          </button>
        </div>
      </div> -->
    </div>

    <app-table
      :id="tableId"
      :options="options"
      :card-view="true"
      @action="getListAction"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../../Demo/Tables/mixins/TableHelpers";
import AppFunction from "../../../../../../../core/helpers/app/AppFunction";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";

export default {
  extends: CoreLibrary,
  name: "GridView",
  mixins: [TableHelpers],
  data() {
    return {
      url: '',
      result: this.$attrs["props"].status,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      request: {},
      tableId: "grid-view-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: actions.BID_RESPONSE,
        cardViewComponent: "job-response-grid",
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
          {
            title: this.$t("user"),
            type: "media-object",
            key: "media-object",
            mediaTitleKey: "title",
            mediaSubtitleKey: "email",
            default: AppFunction.getAppUrl("images/avatar-demo.jpg"),
            modifier: (value, row) => {
              return value; // imag url
            },
            isVisible: true,
          },
          {
            title: this.$t("description"),
            type: "text",
            key: "description",
          },
          {
            title: this.$t("start_date"),
            type: "text",
            key: "start_date",
          },
          {
            title: this.$t("end_date"),
            type: "text",
            key: "end_date",
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
            modifier: (value) => {
              let ClassName = "danger";

              if (value === "active") ClassName = `success`;
              else if (value === "invited") ClassName = `warning`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            },
          },
          {
            title: this.$t("start_date"),
            type: "text",
            key: "start_date",
          },
          {
            title: this.$t("gender"),
            type: "custom-html",
            key: "gender",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("accept"),
            // icon: "eye",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },
          {
            title: this.$t("reject"),
            // icon: "eye",
            type: "none",
            // component: 'app-add-modal',
            // modalId: 'demo-add-edit-Modal',
          },
          //   {
          //     title: this.$t("edit"),
          //     icon: "edit",
          //     type: "none",
          //     component: "app-add-modal",
          //     modalId: "demo-add-edit-Modal",
          //   },
          // {
          //     title: this.$t('delete'),
          //     icon: 'trash',
          //     type: 'none',
          //     component: 'app-confirmation-modal',
          //     modalId: 'demo-delete',
          // },
          //   {
          //     title: this.$t("view"),
          //     icon: "calendar",
          //     type: "none",
          //     component: "app-add-modal",
          //     modalId: "demo-add-edit-Modal",
          //   },
        ],
        filters: [
          //   {
          //     title: this.$t("date"),
          //     type: "range-picker",
          //     key: "date",
          //     option: ["today", "thisMonth", "last7Days", "nextYear"],
          //   },
          {
            title: this.$t("is_private"),
            type: "checkbox",
            key: "is_private",
            option: [
              { id: "0", value: "Public" },
              { id: "1", value: "Private" },
            ],
          },
          {
            title: this.$t("location"),
            type: "drop-down-filter",
            key: "search select",
            option: [
              { id: "0", value: "UK" },
              { id: "1", value: "USA" },
            ],
          },
          {
            title: this.$t("region"),
            type: "drop-down-filter",
            key: "search select",
            option: [
              { id: "0", value: "Public" },
              { id: "1", value: "Private" },
            ],
          },
          {
            title: this.$t("threshold"),
            type: "drop-down-filter",
            key: "search select",
            option: [
              { id: "0", value: "Threshold 1" },
              { id: "1", value: "Threshold 1" },
            ],
          },
          //   {
          //     title: this.$t("status"),
          //     type: "checkbox",
          //     key: "status",
          //     option: [
          //       { id: "completed", value: "Completed" },
          //       { id: "incomplete", value: "Incomplete" },
          //       // {id: 'invited', value: 'Invited'},
          //     ],
          //   },
          {
            title: this.$t("search_and_select_category"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  methods: {
    getListAction(rowData, actionObj, active) {
      if (actionObj.title == this.$t("accept")) {
        this.acceptForm(rowData.id);
      } else if (actionObj.title == this.$t("reject")) {
        this.rejectForm(rowData.id);
      }
    },

    getBodies(status) {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // let id = split[6].split("?")[0];
      // let status = this.$attrs['props'];
      // this.request.id = id;
      // this.request.status = status;

      
      let id = this.$attrs['props'].id;
    
    
      this.options.url = actions.BID_RESPONSE + "?status="+status+ "&id="+id;
      this.$hub.$emit("reload-" + this.tableId);
      // this.url = actions.BID_RESPONSE + "?status="+status+ "&id="+id;
      // this.url = this.options.url ;
    },
    acceptForm(statusId) {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // let id = split[6].split("?")[0];
      let id = this.$attrs['props'].id;
      let input = {};
      input.job_id = id;
      input.status_id = statusId;
      axiosPost(actions.FORM_ACCEPT, input)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((errors) => {
          
        }).finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    rejectForm(statusId) {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // let id = split[6].split("?")[0];
      let id = this.$attrs['props'].id;
      let input = {};
      input.job_id = id;
      input.status_id = statusId;
      axiosPost(actions.FORM_REJECT, input)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((errors) => {
          
        }).finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    searchAndSelectFilterOptions() {
      this.axiosGet(actions.CATEGORIES).then((response) => {
        let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select_category")
        );

        name.option = response.data.map((name) => {
          return {
            id: name.id,
            value: name.value,
          };
        });
      });
    },
  },
  mounted() {
    
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    
    // let id = split[6].split("?")[0];
    let status = this.$attrs['props'].status;
    this.getBodies(status);
    this.isCardView = true;
    // vm.$forceUpdate();
  },
  watch: {
    $attrs: function (newVal, oldVal) {
      let t = this.$attrs['props'].status;
      
       this.getBodies(t);
                 
    },
  },
};
</script>
